import { infer as Infer, z } from 'zod/v4';

/**
 * Mirrors the request body of POST /api/report/student/{studentId}.
 *
 * `from` and `to` are calendar days (YYYY-MM-DD) rather than datetimes: the
 * report covers whole days and the BE widens them to the full day itself.
 * Both are nullable — omitting them reports on the student's whole history.
 */
export const studentReportSchema = z
  .object({
    from: z.iso.date({ message: 'Nieprawidłowa data' }).nullable(),
    to: z.iso.date({ message: 'Nieprawidłowa data' }).nullable(),
    desc: z.string().trim().max(500, 'Komentarz nie może przekraczać 500 znaków').nullable(),
    emailParents: z.boolean(),
  })
  // ISO day strings sort lexicographically, so a plain comparison is enough.
  .refine(({ from, to }) => !from || !to || from <= to, {
    message: 'Data końcowa musi być późniejsza niż początkowa',
    path: ['to'],
  });

export type StudentReportSchema = Infer<typeof studentReportSchema>;
